
export interface LineSubscription {
    sourceId: string,
    deviceId: string,
    lineId: string,
    ltmi: string,
    settings: LineSettings | undefined,
    bulkData: Array<any>,
    data: Array<any>,
    _data: Array<any>
}

// LineSettings contained within TelemetryNode of SourceNodes tree
export interface LineSettings {
    lineColor: string // rgb color
    showSourceName: boolean
    showDeviceName: boolean
    showUoMSymbol: boolean
    showCustomName: boolean
    customName: string
    yAxisPosition: Y_AXIS_POSITION // none, left, right
    minYaxis: number | null
    maxYaxis: number | null
    showTitle: boolean
    function: FUNC_TYPE
    functionTimeframe: number
}

export enum POSITION {
    Top = 'top',
    Bottom = 'bottom',
    Left = 'left',
    Right = 'right'
}

export enum ALIGN {
    Start = 'start',
    Center = 'center',
    End = 'end'
}

export interface AnalyzeSettings {
    // Contains the entire hierarchy of selected items
    startDateTime: number
    endDateTime: number
    showLegend: boolean
    title: {
        showTitle: boolean
        text: string
        position: POSITION
        align: ALIGN
        font: {
            weight: string
            size: number
        }
    }
    sourceNodes: Array<any> // SourceNodes contain LineSettings
}

// Defaults are used by Dashboard for defaults in Line Chart Widget
export const ANALYZE_DEFAULT: AnalyzeSettings = {
    startDateTime: 0,
    endDateTime: 0,
    showLegend: true,
    title: {
        showTitle: false,
        text: "",
        position: POSITION.Bottom,
        align: ALIGN.Center,
        font: {
            weight: 'bolder',
            size: 16
        }
    },
    sourceNodes: [], // Lines/Settings are contained within SourceNodes
} // ANALYZE_DEFAULT

export enum Y_AXIS_POSITION {
    NONE = 'none',
    LEFT = 'left',
    RIGHT = 'right'
}

export enum TIME_HORIZON {
    MINUTES = 'minutes',
    HOURS = 'hours',
    DAYS = 'days',
    WEEKS = 'weeks'
}

export enum FUNC_TYPE {
    REALTIME = "realtime",
    AVERAGE = "average",
    MINMAX = "minmax"
}

export interface TimeHorizon {
    id: any;
    local: string;
    label: string;
}
